import { ConfigService } from '../../'

/*& Models/Configs/Header
	# HeaderConfig
*/
export class HeaderConfig {
	public banner		= ''
	public color		= '#F00'
	public geofence	= ''

	constructor(private config: ConfigService) {}

	update(config: any): HeaderConfig {
		if (typeof config.header === 'object') {
			this.color = this.config.getColor(config.header.color, this.color)

			if (typeof config.header.banner === 'string') {
				if (config.header.banner.indexOf('geofence:') > -1) {
					this.geofence = config.header.banner.substring(9, config.header.banner.length)
				} else {
          this.banner = config.header.banner;
				}
			}
		}

		return this
	}
}



// WEBPACK FOOTER //
// ./src/app/electraLib/model/config/headerConfig.ts